import React, { PureComponent } from 'react';
import {
  Nav,
  NavItem,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row
} from 'reactstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

// ducks
import { fetch } from '../../ducks/AssistedLivingSearch';

// components
import LoadError from '../../components/load-error/load-error';
import AssistedLivingCard from '../../partials/assisted-living-card/assisted-living-card';

class AssistedLivingDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { error, record, searchURI, detailURI, id, isLoading, loaded } = this.props;

    const isLoaded = !isLoading && loaded === id;

    return (
      <Container className={cx(styles.AssistedLivingDetail)}>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/assisted-living">
              <BreadcrumbItem>
                <Link to="/assisted-living">Assisted Living Search</Link>
              </BreadcrumbItem>
            </LinkContainer>
            {isLoaded && <BreadcrumbItem active>{id}</BreadcrumbItem>}
          </Breadcrumb>
        </Row>
        <Container className={`${BS.breadcrumb2}`}>
          <Row>
            <Nav horizontal="space-between" className={`${BS.mb3}`}>
              {searchURI && !detailURI && (
                <NavItem>
                  <Button color="link" tag={Link} to={searchURI}>
                    &lt; Back
                  </Button>
                </NavItem>
              )}
              {detailURI && (
                <NavItem>
                  <Button color="link" tag={Link} to={detailURI}>
                    &lt; Back
                  </Button>
                </NavItem>
              )}
            </Nav>
          </Row>
        </Container>
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        {isLoaded && (
          <React.Fragment>
            <AssistedLivingCard data={record.toJS()} />
          </React.Fragment>
        )}
      </Container>
    );
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id });
    }
  }

  reload() {
    const { load, id } = this.props;

    if (load && id) {
      load({ id });
    }
  }
}

export default connect(
  (state, props) => {
    const id = props.match.params.id;
    const { searchURI, detailURI } = URI(state.routing.location.search).search(true);
    const { pathname, search = {} } = state.routing.location;
    return {
      id,
      record: state.AssistedLivingSearch.getIn(['detail', 'record']),
      isLoading: state.AssistedLivingSearch.getIn(['detail', 'loading']),
      loaded: state.AssistedLivingSearch.getIn(['detail', 'loaded']),
      error: state.AssistedLivingSearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-naples-home',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI: pathname && URI(pathname).search(search).toString()
    };
  },
  { load: fetch }
)(AssistedLivingDetail);



// WEBPACK FOOTER //
// ./src/containers/AssistedLivingDetail/AssistedLivingDetail.js